import { disableBodyScroll, enableBodyScroll } from '@cell/cell-core/body-scroll-lock';
import Component from '@cell/cell-core/component/component';

import './drawer.scss';

class Drawer extends Component {
  constructor() {
    super();

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  componentDidMount() {
    globalThis.on(`c-button.click.open-${this.parsedDataset.name}`, this.open);

    this.on('c-button.click.close', this.close);

    // Handle clicks outside cart drawer.
    this.on('click', (event) => {
      if (event.target.matches('.Drawer__Overlay')) {
        this.close();
      }
    });
  }

  open() {
    this.classList.add('Drawer--Active');

    setTimeout(() => {
      this.classList.add('Drawer--Visible');

      disableBodyScroll();
    }, 10);
  }

  close() {
    this.classList.remove('Drawer--Visible');

    setTimeout(() => {
      this.classList.remove('Drawer--Active');

      enableBodyScroll();

      this.emit('close');

      // The time needed to finish cart drawer overlay and wrapper animation.
    }, 450);
  }
}

customElements.define('c-drawer', Drawer);
